import React, { useEffect, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { createGlobalStyle } from 'styled-components';
import { validateEmail } from '../../utils/validation';
import { ERROR_CODES } from '../../utils/errorMessages';
import SignupCard from './SignUpCard';
import SignUpContent, { BrandsList } from './SignUpContent';
import AuthLayout from '../../components/Layout/Auth/AuthLayout';
import { CONSTS } from '../../const';
import { useWindowSize } from '@react-hook/window-size/throttled';
import { getErrMsgFromResp, handleErrorToast } from '../../utils/errorHandler';
import { graphqlClient } from '../../utils/client/graphql';
import { SIGNUP_MUTATION } from '../../graphql/queries';

const GlobalStyles = createGlobalStyle`
body {
     background: #e9f7ff;
}
`;

const SignUp = () => {
  const [loading, setLoading] = useState(false);
  const [width] = useWindowSize();
  const [email, setEmail] = useState('');
  const [error, setError] = useState('');
  const [agreeToTerms, setAgreeToTerms] = useState(false);
  const [signupDisabled, setSignupDisabled] = useState(false);
  const navigate = useNavigate();

  const handleSignup = async () => {
    setLoading(true);
    const emailValidation = validateEmail(email);
    if (!emailValidation.isValid) {
      setError(emailValidation.error);
      return;
    }
    if (!agreeToTerms) {
      setError('Please accept the Terms & Conditions');
      return;
    }

    try {
      const response = await graphqlClient.request(SIGNUP_MUTATION, {
        email: email,
      });
      console.log('response', response);

      const signup = response?.signup;
      const status = signup?.status;
      const errorCode = signup?.errorCode;
      const data = signup?.data;

      switch (errorCode) {
        case ERROR_CODES.OTP_REQUIRED:
          console.log('in here');
          navigate('/signup', {
            state: {
              screen: 'otp',
              email: email,
              otpKey: data?.otpKey,
              resendTime: data?.resendReadyTime,
              sourceState: data?.sourceType,
            },
          });
          break;

        // case ERROR_CODES.TRY_AFTER_SOME_TIME:
        //   setSignupDisabled(true);
        //   setTimeout(() => setSignupDisabled(false), 300000); // 5 minutes
        //   break;

        // case ERROR_CODES.MAX_OTP_LIMIT_EXCEEDED:
        //   setSignupDisabled(true);
        //   // Could show a countdown until next day
        //   break;

        default:
          if (status === CONSTS.VER || status === CONSTS.ERR) {
            throw response;
          }
      }
    } catch (err) {
      setError(getErrMsgFromResp(err));
      console.error('Signup error:', err);
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    handleErrorToast(error);
    setTimeout(() => {
      setError('');
    }, 500);
  }, [error]);

  return (
    <AuthLayout leftContent={<SignUpContent />}>
      <GlobalStyles />
      <SignupCard
        email={email}
        setEmail={setEmail}
        error={error}
        agreeToTerms={agreeToTerms}
        setAgreeToTerms={setAgreeToTerms}
        handleSignup={handleSignup}
        signupDisabled={signupDisabled}
        loading={loading}
      />
      {/* {width <= 768 && <BrandsList />} */}
    </AuthLayout>
  );
};

export default SignUp;
